import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ProfileView from "./ProfileView"
import MySideBar from '../common/MySideBar';


export class Profile extends Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  render() {
    return (
      <div>
        <MySideBar>
          <ProfileView 
          getProfile={this.props.actions.getProfile}
          profileInfo={this.props.profile.profileInfo}
          updatePersonInfo={this.props.actions.updatePersonInfo}
          setLoading={this.props.actions.setLoading}
          updatePassword={this.props.actions.updatePassword}
          setLoadingPassword={this.props.actions.setLoadingPassword}
          unsetLoadingPassword={this.props.actions.unsetLoadingPassword}
          loadingPerson={this.props.profile.loadingPerson}
          loadingChangePassword={this.props.profile.loadingChangePassword}
          changePasswordStatus={this.props.profile.changePasswordStatus}
          checkingMessage={this.props.profile.checkingMessage}
          updatingSuccess={this.props.profile.updatingSuccess}
          uploadAvatar={this.props.actions.uploadAvatar}
          /> 
        </MySideBar>        
      </div>      
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    profile: state.profile,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/features/profile/Profile.js